import { Container } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';
import { tweenPower2In, tweenPower2Out } from '../../lib/util/tweens';

export class SparkleAnimation extends Container implements IAnimation {
  private sparkles: ParticleEmitter;

  constructor(
    public opts: { width: number; height: number } = { width: 50, height: 50 },
  ) {
    super();
    this.sparkles = this.createEmitter();
    this.addChild(this.sparkles.view);
  }

  public async start(): Promise<void> {
    return this.sparkles.start();
  }

  public stop() {
    this.sparkles.stop();
  }

  private createEmitter(): ParticleEmitter {
    return app.particles.create(
      {
        textures: [getMatch2AssetPath('fx.basic/fx.basic.sparkle.png')],
        rate: 0.5,
        limit: 600,
        duration: 1,
        scale: { x: 0, y: 0 },
        angularVelocity: [0, 0.5],
        behaviors: [
          {
            type: 'emiterShape',
            shape: 'rectangle',
            width: this.opts.width,
            height: this.opts.height,
          },
          {
            type: 'scale',
            to: [1.2, 1.5],
            tween: tweenPower2Out,
          },
          { type: 'fade', to: 0, tween: tweenPower2In },
          { type: 'kinematic' },
        ],
      },
      true,
    );
  }
}
